import { type FunctionComponent, useEffect } from 'react';

import { useSsrContext } from '@dr.pogodin/react-utils';

import Throbber from 'components/Throbber';

import { useExperience, useSession } from 'hooks';
import { E_EXPERIENCE } from 'utils';

import Session from './Session';

import './style.scss';

export const SessionPage: FunctionComponent = () => {
  const ssr = useSsrContext(false);

  const experience = useExperience();
  const session = useSession();

  const busy = experience.busy || session.busy;
  const bad = !busy && (
    !experience.data?.experience.videos.length || !session.data
  );

  useEffect(() => {
    if (bad) location.href = E_EXPERIENCE;
  }, [bad]);

  if (bad && ssr) ssr.setStatus(303 /* See Other */, E_EXPERIENCE);

  if (busy) return <div styleName="throbber"><Throbber /></div>;
  if (bad) return null;
  return <Session />;
};
